import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { ExpectedClosingDateStore } from '../../../stores/documentForms/expectedClosingDateStore';
import { createSelectField, createTextField } from '@roc/ui';
import { OTHER_ADJOURNMENT_REASON, reasonForAdjournmentOptions } from './constants';

export type ReasonForAdjournmentProps = {
  store: ExpectedClosingDateStore;
};

export const ReasonForAdjournment = observer(
  (props: ReasonForAdjournmentProps) => {
    const {store} = props;

    return (
      <>
        <Grid container spacing={1} justify="center">
          <Grid item xs={12}>
            {createSelectField({
              store,
              testId: 'reasonForAdjournment',
              fieldName: 'reasonForAdjournment',
              label: 'Reason for Adjournment',
              options: reasonForAdjournmentOptions,
              disabled: !store.shouldBeAbleToSubmitExpectedClosingDate(),
            })}
          </Grid>
          {store.form.fields.reasonForAdjournment.value === OTHER_ADJOURNMENT_REASON && (
            <Grid item xs={12}>
              {createTextField({
                store,
                testId: 'otherAdjournmentReason',
                fieldName: 'otherAdjournmentReason',
                label: 'Please specify if Other',
                disabled: !store.shouldBeAbleToSubmitExpectedClosingDate(),
              })}
            </Grid>
          )}
        </Grid>
      </>
    );
  }
)
